import Vue from 'vue'
import moment from 'moment'

const VueMoment = {

	install(Vue) {

		Vue.prototype.$moment = moment

	}

}

Vue.use(VueMoment)

export default VueMoment



// WEBPACK FOOTER //
// ./src/initializers/moment.js